<script lang="ts" context="module">
    import MessageBasicGroupChatCreate from "./Widget/MessageBasicGroupChatCreate.svelte"
    import MessagePhoto from "./Widget/MessagePhoto.svelte"
    import MessageText from "./Widget/MessageText.svelte"
    import MessageUnsupported from "./Widget/MessageUnsupported.svelte"
    import MessageVideo from "./Widget/MessageVideo.svelte"
    import MessageSticker from "./Widget/MessageSticker.svelte"
    import MessageAnimatedEmoji from "./Widget/MessageAnimatedEmoji.svelte"
    import MessageContactRegistered from "./Widget/MessageContactRegistered.svelte"
    import MessageDocument from "./Widget/MessageDocument.svelte"
    import MessageContact from "./Widget/MessageContact.svelte";
    import MessageVoiceNote from "./Widget/MessageVoiceNote.svelte";
    import MessageVideoNote from "./Widget/MessageVideoNote.svelte";
    import MessageAudio from "./Widget/MessageAudio.svelte";
    let widgets = {
        MessageBasicGroupChatCreate,
        MessagePhoto,
        MessageText,
        MessageUnsupported,
        MessageVideo,
        MessageSticker,
        MessageAnimatedEmoji,
        MessageContactRegistered,
        MessageDocument,
        MessageContact,
        MessageVoiceNote,
        MessageVideoNote,
        MessageAudio,
    }
</script>
<script lang="ts">
    import type {ChatMessageAttachmentData} from "../Types";

    export let entity: any
    export let telegramMessageId: string
    export let isChannel: string
    export let attachments: ChatMessageAttachmentData[] = []
    let messageType = null;

    if (entity && '@type' in entity && entity['@type'].length > 0) {
        messageType = entity["@type"][0].toUpperCase() + entity["@type"].substring(1)
    }
    $: widget = messageType
</script>

{#if (widgets.hasOwnProperty(widget))}
    <svelte:component this={widgets[widget]}
                      {attachments}
                      {entity}
                      {isChannel}
                      {telegramMessageId}/>
{:else}
    <div class="alert alert-danger">
        Не підтримуваний віджет
        {JSON.stringify(entity)}
    </div>
{/if}
